<template>
    <jc-field icon="img-icon icon-dialog" @blur="handleBlur" maxlength="6" v-model="currentValue" placeholder="短信验证码">
        <span slot="append" class="send-tip-text" @click.stop="open">{{send ? `重新发送(${selfTimeout}秒)` : '发送验证码'}}</span>
    </jc-field>
</template>

<script>
import Sms from '@/utils/mixins/sms'
export default {
  name: 'sms-field',
  mixins: [Sms],
  props: {
    value: {},
    mobile: {},
    timeout: {
      type: [Number, String],
      default: 60
    },
    smsCode: {},
    beforeSend: Function // 异步函数或Promise函数，返回true或false
  },
  methods: {
    handleBlur (e) {
      this.$emit('blur', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cell/sms-field.vue